import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Feedback360Summary, FormValues } from './types';
import { addMoreFeedback360Requests, createFeedback360Requests, getFeedback360Requests, getFeedback360Result } from '../../../../../../services/feedback360.service';

export const useGetFeedback360Result = () => {
  return useQuery<Feedback360Summary | null>(
    'feedback360-result',
    getFeedback360Result,
    {
      refetchOnWindowFocus: false
    }
  );
};

export const useGetFeedback360 = () => {
  return useQuery('feedback360-requests', getFeedback360Requests, {
    refetchOnWindowFocus: false
  });
};

export const useCreateFeedback360 = () => {
  const queryClient = useQueryClient();
  
  return useMutation(
    (data: FormValues) => {
      const transformedData = {
        items: data.contacts
          .filter(contact => contact.email && contact.type)
          .map(contact => ({
            email: contact.email,
            type: contact.type
          })),
        comment: data.comment || undefined
      };
      return createFeedback360Requests(transformedData);
    },
    {
      onSuccess: () => {
        // Refetch feedback requests to update the UI after creating new feedback
        queryClient.refetchQueries('feedback360-requests');
      }
    }
  );
};

export const useAddFeedback360 = () => {
  const queryClient = useQueryClient();
  
  return useMutation(
    (data: FormValues) => {
      // Only include new contacts (not disabled) that have valid email and type
      const transformedData = {
        items: data.contacts
          .filter(contact => !contact.disabled && contact.email && contact.type)
          .map(contact => ({
            email: contact.email,
            type: contact.type
          }))
      };
      return addMoreFeedback360Requests(transformedData);
    },
    {
      onSuccess: () => {
        // Refetch feedback requests to update the UI after adding more feedback
        queryClient.refetchQueries('feedback360-requests');
      }
    }
  );
};